var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 22.536,
    viewBox: "0 0 30 22.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1216",
    "data-name": "Group 1216",
    transform: "translate(-295.623 -116.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    transform: "translate(295.623 120.157)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 19,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 18,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16760",
    "data-name": "Path 16760",
    d: "M1094.292,124.647l2.189-2.526h9.644l2.134,2.526Z",
    transform: "translate(-790.494 -5)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(300.623 122.157)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    transform: "translate(304.623 122.157)",
    fill: "none",
    stroke: "#b1b1b1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 7,
    rx: 6.5,
    ry: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 7,
    rx: 6,
    ry: 6.5,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.cc2411cab6f343cb6dfff5d9a2c21501.svg";
export { ForwardRef as ReactComponent };